import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { useSearchParams } from 'react-router-dom';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useContext } from 'react';
import { AuthContext } from 'context/authContext';

export default function useGetAllProjects(active) {
  const [searchParams] = useSearchParams();

  const { authState } = useContext(AuthContext);

  return useQuery(
    [
      'get-all-projects',
      active,
      searchParams.get('priority'),
      searchParams.get('status'),
      searchParams.get('search'),
      authState?.employee_id,
    ],
    async () => {
      const res = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.PROJECT_API, {
          is_active: active ? 'True' : 'False',
          priority: searchParams.get('priority'),
          status: searchParams.get('status'),
          search: searchParams.get('search'),
          employee_id: authState?.is_admin ? null : authState?.employee_id,
        })
      );
      return res.data;
    }
  );
}
